import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Score from '../Score';
import './styles.scss';

const Rating = ({ onNumberClick, position }) => {
  const rating = [];

  for (let i = 1; i < 11; i++) {
    rating.push({ active: false, score: i });
  }

  const [score, setScore] = useState(rating);
  const setActiveRating = number => {
    const result = score.map(item => ({ ...item, active: item.score === number ? !item.active : false }));

    setScore(result);
    onNumberClick(number);
  };

  return (
    <div className="rating-wrapper">
      <h2 className="rating-wrapper__info">
        How satisfied were you with the results for <br />"{position}"
      </h2>
      <div className="rating-wrapper__rating">
        {score.map(({ score, active }) => (
          <Score active={active} key={score} score={score} setActiveRating={setActiveRating} />
        ))}
      </div>
      <div className="rating-wrapper__satisfaction">
        <span>Very unsatisfied</span>
        <span>Very satisfied</span>
      </div>
    </div>
  );
};

Rating.propTypes = {
  onNumberClick: PropTypes.func.isRequired,
  position: PropTypes.string.isRequired,
};

export default Rating;
